import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { MediaQuery } from '@grandvisionhq/common';
import { StepForm } from '@grandvisionhq/configurator';
import { useIntl } from '@grandvisionhq/state';
import { Upload } from '@grandvisionhq/upload';
import '../../../../state/actions.js';
import { PD_SCOPE, RX_SCOPE, PRESCRIPTION_STEP_UPLOAD_DESCRIPTION_ID } from '../../../../state/constants.js';
import '../../../../state/add-to-cart/selectors.js';
import '../../../../state/bundles/selectors.js';
import '../../../../state/bundles/reducer.js';
import '../../../../state/configurator/selectors.js';
import '../../../../state/configurator/reducer.js';
import '../../../../state/products/selectors.js';
import '../../../../state/products/reducer.js';

var PrescriptionUploadForm = (_param)=>{
    var { className , onSubmit , onStatusChange , uploadState , showPdUpload =true  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "onSubmit",
        "onStatusChange",
        "uploadState",
        "showPdUpload"
    ]);
    const { getLabel  } = useIntl();
    const isOnDesktop = MediaQuery.useIsAbove(MediaQuery.BreakpointName.TABLET_PORTRAIT);
    const uploadLayout = isOnDesktop ? 'vertical' : 'horizontal';
    const handlePDStatusChange = React.useCallback((status)=>onStatusChange(status, PD_SCOPE)
    , [
        onStatusChange
    ]);
    const handleRXStatusChange = React.useCallback((status)=>onStatusChange(status, RX_SCOPE)
    , [
        onStatusChange
    ]);
    var _RX_SCOPE, _PD_SCOPE;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(StepForm, {
        className: classnames('prescription-upload-form', className, {
            'prescription-upload-form--one-column': !showPdUpload,
            'prescription-upload-form--two-columns': showPdUpload
        }),
        "data-t": rest['data-t'],
        onSubmit: onSubmit
    }, /*#__PURE__*/ React.createElement(Upload, {
        variant: uploadLayout,
        id: "rx-upload",
        "data-t": "rx-upload",
        iconName: "upload-prescription",
        title: getLabel('products.glasses.upload.rx.title'),
        "aria-describedby": PRESCRIPTION_STEP_UPLOAD_DESCRIPTION_ID,
        onStatusChange: handleRXStatusChange,
        uploadStatus: (_RX_SCOPE = uploadState[RX_SCOPE]) !== null && _RX_SCOPE !== void 0 ? _RX_SCOPE : {
            status: 'IDLE'
        },
        referenceId: RX_SCOPE,
        scope: RX_SCOPE,
        className: "prescription-upload-form__uploader"
    }), showPdUpload && /*#__PURE__*/ React.createElement(Upload, {
        variant: uploadLayout,
        id: "pd-upload",
        "data-t": "pd-upload",
        iconName: "upload-pd",
        title: getLabel('products.glasses.upload.pd.title'),
        "aria-describedby": PRESCRIPTION_STEP_UPLOAD_DESCRIPTION_ID,
        onStatusChange: handlePDStatusChange,
        uploadStatus: (_PD_SCOPE = uploadState[PD_SCOPE]) !== null && _PD_SCOPE !== void 0 ? _PD_SCOPE : {
            status: 'IDLE'
        },
        referenceId: PD_SCOPE,
        scope: PD_SCOPE,
        className: "prescription-upload-form__uploader"
    })));
};

export { PrescriptionUploadForm };
//# sourceMappingURL=PrescriptionUploadForm.js.map
